import { createSlice } from "@reduxjs/toolkit";
import { AuthState } from "./auth.types";
import { triggerOtpThunk, verifyOtpThunk, verifyPinThunk, setPinThunk } from "./authThunk";

const initialState: AuthState = {
    mobileNumber: "",
    deviceId: "",
    loading: false,
    otpSent: false,
    verified: false,
    isPinRequired: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setMobileNumber(state, action) {
            state.mobileNumber = action.payload;
            state.error = undefined;
        },
        setDeviceId(state, action) {
            state.deviceId = action.payload;
        },
        setConsentHandle(state, action) {
            state.consentHandle = action.payload;
            state.error = undefined;
        },
        resetAuth(state) {
            return { ...initialState, deviceId: state.deviceId };
        },
        setSdkParams(state, action) {
            if (action.payload.mobileNumber) state.mobileNumber = action.payload.mobileNumber;
            if (action.payload.userId) state.userId = action.payload.userId;
            if (action.payload.deviceId) state.deviceId = action.payload.deviceId;
            if (action.payload.panNumber) state.panNumber = action.payload.panNumber;
            if (action.payload.emailId) state.emailId = action.payload.emailId;
        },
    },
    extraReducers: (builder) => {
        builder
            // Trigger OTP
            .addCase(triggerOtpThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(triggerOtpThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.otpSent = true;
                // Save the handle used for this specific attempt
                if (action.payload.usedConsentHandle) {
                    state.consentHandle = action.payload.usedConsentHandle;
                } else if (action.meta.arg.consentHandle) {
                    state.consentHandle = action.meta.arg.consentHandle;
                }
                if (action.payload.ExistUser !== undefined) {
                    state.existUser = action.payload.ExistUser;
                }
                if (action.payload.UUID) state.uuid = action.payload.UUID;
            })
            .addCase(triggerOtpThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Verify OTP
            .addCase(verifyOtpThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(verifyOtpThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.verified = true;
                state.sessionId = action.payload.sessionId;
                if (action.payload.consentHandle) {
                    state.consentHandle = action.payload.consentHandle;
                }
                if (action.payload.existUser !== undefined) {
                    state.existUser = action.payload.existUser;
                }
                if (action.payload.uuid) state.uuid = action.payload.uuid;
            })
            .addCase(verifyOtpThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Verify PIN
            .addCase(verifyPinThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(verifyPinThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.verified = true;
                state.sessionId = action.payload.sessionId;
                if (action.payload.consentHandle) {
                    state.consentHandle = action.payload.consentHandle;
                }
                if (action.payload.uuid) state.uuid = action.payload.uuid;
            })
            .addCase(verifyPinThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Set PIN
            .addCase(setPinThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(setPinThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.verified = true;
                state.sessionId = action.payload.sessionId;
                if (action.payload.consentHandle) {
                    state.consentHandle = action.payload.consentHandle;
                }
                if (action.payload.uuid) state.uuid = action.payload.uuid;
            })
            .addCase(setPinThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { setMobileNumber, setDeviceId, setConsentHandle, setSdkParams } = authSlice.actions;
export default authSlice.reducer;
